import * as React from "react";
const LinkIcon = (props: any) => (
  <svg
    width="current"
    height="current"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1319_27208"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <rect width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1319_27208)">
      <path
        d="M14.2821 15.8333V13.6154H12.0642V12.5321H14.2821V10.3141H15.3654V12.5321H17.5834V13.6154H15.3654V15.8333H14.2821ZM8.83979 13.6154H6.03212C5.03187 13.6154 4.17925 13.2624 3.47425 12.5566C2.76925 11.8508 2.41675 10.9972 2.41675 9.99575C2.41675 8.99432 2.76925 8.14211 3.47425 7.43912C4.17925 6.73614 5.03187 6.38464 6.03212 6.38464H8.83979V7.46793H6.03212C5.33233 7.46793 4.73537 7.715 4.24125 8.20912C3.74712 8.70325 3.50006 9.30021 3.50006 10C3.50006 10.6998 3.74712 11.2967 4.24125 11.7909C4.73537 12.285 5.33233 12.5321 6.03212 12.5321H8.83979V13.6154ZM7.20842 10.5416V9.45835H12.7917V10.5416H7.20842ZM17.5834 10H16.5001C16.5001 9.30021 16.253 8.70325 15.7589 8.20912C15.2647 7.715 14.6678 7.46793 13.968 7.46793H11.1603V6.38464H13.968C14.9682 6.38464 15.8209 6.73714 16.5259 7.44214C17.2309 8.14713 17.5834 8.99975 17.5834 10Z"
        fill="current"
      />
    </g>
  </svg>
);
export default LinkIcon;
